import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material"
import React, { useEffect, useRef } from "react"
import { Box } from "@mui/system"
import LinearProgress from "@mui/material/LinearProgress"
import { useNavigate } from "react-router-dom"
import { clearTimer } from "../../../../core/services/helper-service"
import CancelButton from "../../../../components/buttons/CancelButton/CancelButton"
import { pagesUrl } from "../../../../core/appConstants"

const TIME_TO_FILL_PROGRESS_IN_SECONDS = 180
const MAX_VALUE = 95
const STEP_TIME_IN_MILLISECONDS = (TIME_TO_FILL_PROGRESS_IN_SECONDS * 1000) / MAX_VALUE

interface IProps {
  isOpen: boolean
  progress: number
  setProgress: React.Dispatch<React.SetStateAction<number>>

  onClose(): void
}

export function ReEstimateDialog({ isOpen, onClose, progress, setProgress }: Readonly<IProps>): React.JSX.Element {
  const navigate = useNavigate()
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (isOpen) {
      intervalIdRef.current = setInterval(() => {
        setProgress((prev) => (prev < MAX_VALUE ? prev + 1 : prev))
      }, STEP_TIME_IN_MILLISECONDS)
    }

    return () => {
      setProgress(0)
      clearTimer(intervalIdRef)
    }
  }, [setProgress, isOpen])

  return (
    <Dialog
      open={isOpen}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose()
        }
      }}>
      <DialogTitle>Re-calcul en cours</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box>Les estimations de ce projet sont en cours de ré-estimation suite à un changement de sa configuration.</Box>
            <Box>Veuillez patienter...</Box>
          </Grid>
          <Grid item xs={12}>
            <LinearProgress variant="determinate" value={progress} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton label="Retour" onClick={() => navigate(pagesUrl.PROJECTS_PAGE)} />
      </DialogActions>
    </Dialog>
  )
}
